import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AppUser = {
  __typename?: 'AppUser';
  createdAt: Scalars['DateTime']['output'];
  getUserScenarios: Array<UserScenario>;
  id: Scalars['String']['output'];
};

/** A basic product with only the common fields */
export type BasicProduct = Product & {
  __typename?: 'BasicProduct';
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']['output']>;
  /** The uuid of the product */
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  /** The human readable name of the visual door */
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String']['output'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']['output']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']['output']>;
  showForAllDoors?: Maybe<Scalars['Boolean']['output']>;
  showForDoorTypes?: Maybe<Array<ProductType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']['output']>;
};

export type CategoryOptionsToSelect = {
  __typename?: 'CategoryOptionsToSelect';
  categoryId: Scalars['String']['output'];
  optionsToSelect?: Maybe<Array<Scalars['String']['output']>>;
  selectAllOptions?: Maybe<Scalars['Boolean']['output']>;
};

export type ColorInput = {
  imageButtonsBackground?: InputMaybe<Scalars['String']['input']>;
  imageButtonsText?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  primaryText?: InputMaybe<Scalars['String']['input']>;
  uploadPanelBackground?: InputMaybe<Scalars['String']['input']>;
  uploadPanelText?: InputMaybe<Scalars['String']['input']>;
};

export type CornerPosition = {
  __typename?: 'CornerPosition';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type CornerPositionInput = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type CreateJobInput = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  type: JobType;
};

export type CreateOrUpdateShadowProfileInputArguments = {
  shadowImages?: InputMaybe<Array<ShadowImagesInput>>;
  shadowProfileId?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateScenarioResponse = {
  __typename?: 'CreateScenarioResponse';
  showCornerRefinement: Scalars['Boolean']['output'];
  userScenario: UserScenario;
};

export type CreateUserScenarioParameters = {
  /** The customer key for which this user scenario should be created */
  customerKey: Scalars['String']['input'];
  /** The device type used to create/upload this user scenario */
  deviceType?: InputMaybe<DeviceType>;
  /** Specify the start and end of the door location it the uploaded image is horizontal */
  doorLocation?: InputMaybe<DoorLocation>;
  doorTypeId?: InputMaybe<Scalars['String']['input']>;
  /** File upload if the user uses an own photo */
  fileUpload: Scalars['Upload']['input'];
  imageOrientation?: InputMaybe<ImageOrientation>;
};

export type CreateVisualDoorParameters = {
  customAttributeValues?: InputMaybe<Array<CustomAttributeValueInput>>;
  /** The type of the visual door */
  doorTypeId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<MonetaryValueInput>;
  /** The link which should be opened when the user clicks shop now */
  showNowLink: Scalars['String']['input'];
};

/** CursorBasedPageInfo */
export type CursorBasedPageInfoModel = {
  __typename?: 'CursorBasedPageInfoModel';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  type: CustomAttributeType;
};

export type CustomAttributeInput = {
  attributeName: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CustomAttributeSaveInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  optional: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  type: CustomAttributeType;
};

export enum CustomAttributeType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING'
}

export type CustomAttributeValue = {
  __typename?: 'CustomAttributeValue';
  customAttribute: CustomAttribute;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeValueInput = {
  customAttributeId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A customer which provides us with there visual doors and links to our tool from there web shop. */
export type Customer = {
  __typename?: 'Customer';
  applicationUrl: Scalars['String']['output'];
  config: CustomerConfig;
  createdAt: Scalars['DateTime']['output'];
  /** Delivers example images for the customer if a user has no image at hand. */
  exampleImages: ExampleImagesResponse;
  /** The homepage URL of the customer. Used as a link destination when clicking on the customer logo in the app */
  homepageUrl?: Maybe<Scalars['String']['output']>;
  /** The uuid identifying the customer. */
  id: Scalars['String']['output'];
  isInMaintenance?: Maybe<Scalars['Boolean']['output']>;
  /** The unique human readable key of the customer. */
  key: Scalars['String']['output'];
  /** The logo SVG stored in the admin application. Use the logoPath on the customer config resolver to get the logo for which should be used in the application */
  logoSvg?: Maybe<Scalars['String']['output']>;
  /** The name of the customer. */
  name: Scalars['String']['output'];
  statistics: CustomerStatistics;
  visualDoorProvider: VisualDoorProvider;
  widgetUrl: Scalars['String']['output'];
};


/** A customer which provides us with there visual doors and links to our tool from there web shop. */
export type CustomerStatisticsArgs = {
  daysInPast?: InputMaybe<Scalars['Float']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerColor = {
  __typename?: 'CustomerColor';
  imageButtonsBackground?: Maybe<Scalars['String']['output']>;
  imageButtonsText?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  primaryText?: Maybe<Scalars['String']['output']>;
  uploadPanelBackground?: Maybe<Scalars['String']['output']>;
  uploadPanelText?: Maybe<Scalars['String']['output']>;
};

export type CustomerConfig = {
  __typename?: 'CustomerConfig';
  /** Determines if the customer is active or not */
  active: Scalars['Boolean']['output'];
  allowClippedCorners?: Maybe<Scalars['Boolean']['output']>;
  allowMultipleDoors?: Maybe<Scalars['Boolean']['output']>;
  alwaysShowImageButtons?: Maybe<Scalars['Boolean']['output']>;
  colors?: Maybe<CustomerColor>;
  createShadowInpaintingOnUserScenarioUpload?: Maybe<Scalars['Boolean']['output']>;
  cssPath: Scalars['String']['output'];
  customAttributes: Array<CustomAttribute>;
  defaultDoorType: ProductType;
  /** The defaultLanguage of the customer */
  defaultLanguage: Scalars['String']['output'];
  disableProductOrdering?: Maybe<Scalars['Boolean']['output']>;
  disableVisualDoorsOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableDoorTypeDropdownSelection?: Maybe<Scalars['Boolean']['output']>;
  enableShadowInpainting?: Maybe<Scalars['Boolean']['output']>;
  enableVisualDoorsSearch?: Maybe<Scalars['Boolean']['output']>;
  enabledExampleImageSets?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the products are enabled */
  enabledProducts?: Maybe<Scalars['Boolean']['output']>;
  enabledShadowInpaintingOnExampleImages?: Maybe<Scalars['Boolean']['output']>;
  enabledShadowProfiles: Scalars['Boolean']['output'];
  gtmTag?: Maybe<Scalars['String']['output']>;
  hideDownloadButton?: Maybe<Scalars['Boolean']['output']>;
  hideFlipButton?: Maybe<Scalars['Boolean']['output']>;
  hideRefineButtonUnderImage?: Maybe<Scalars['Boolean']['output']>;
  hideShareButton?: Maybe<Scalars['Boolean']['output']>;
  /** The uuid identifying the customer config. */
  id: Scalars['String']['output'];
  imageButtonsArrangement: ImageButtonsArrangement;
  imageButtonsPlacement: ImageButtonsPlacement;
  logoPath?: Maybe<Scalars['String']['output']>;
  logoPlacement: LogoPlacement;
  logoSvgForApplication?: Maybe<Scalars['String']['output']>;
  mainDoorTypeFilter?: Maybe<Array<ProductType>>;
  productLinkType: ProductLinkType;
  productTypes?: Maybe<Array<ProductType>>;
  shopLinkOverwrite?: Maybe<Scalars['String']['output']>;
  showCustomAttributesFilter?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the door vision branding should be shown */
  showDoorVisionBranding: Scalars['Boolean']['output'];
  showGlassLayerInVisualization: Scalars['Boolean']['output'];
  showRefineLayoutAfterUpload: Scalars['Boolean']['output'];
  /** Determines if the user scenario graphs are shown in the overview */
  showUserScenarioGraphsInOverview?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the user scenario counts are shown in the user scenarios tab */
  showUserScenariosCounts?: Maybe<Scalars['Boolean']['output']>;
  showVisitHomepageButton?: Maybe<Scalars['Boolean']['output']>;
  supportedProductTypes?: Maybe<Array<Scalars['String']['output']>>;
  translations?: Maybe<Scalars['String']['output']>;
  translationsPath: Scalars['String']['output'];
  /** Determines if example images should be used or not */
  useExampleImages: Scalars['Boolean']['output'];
  /** Determines if the favorites list should be used */
  useFavoritesList: Scalars['Boolean']['output'];
};


export type CustomerConfigProductTypesArgs = {
  productTypeType?: InputMaybe<ProductTypeType>;
};

export type CustomerSpecificParameters = {
  directDoorsProperties?: InputMaybe<DirectDoorsVisualDoorInputParameters>;
};

export type CustomerStatistics = {
  __typename?: 'CustomerStatistics';
  activeUsers: Scalars['Float']['output'];
  renderings: Scalars['Float']['output'];
  uploads: Scalars['Float']['output'];
};

export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type DirectDoorsVisualDoorInputParameters = {
  collection: Scalars['String']['input'];
  finish: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type DirectDoorsVisualDoorParameters = {
  __typename?: 'DirectDoorsVisualDoorParameters';
  collection: Scalars['String']['output'];
  finish: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Specifies the position of the door corners */
export type DoorCorners = {
  __typename?: 'DoorCorners';
  bottomLeft: CornerPosition;
  bottomRight: CornerPosition;
  doorType: ProductType;
  hasClippedCorners: Scalars['Boolean']['output'];
  index: Scalars['Int']['output'];
  topLeft: CornerPosition;
  topLeftBottom?: Maybe<CornerPosition>;
  topLeftRight?: Maybe<CornerPosition>;
  topRight: CornerPosition;
  topRightBottom?: Maybe<CornerPosition>;
  topRightLeft?: Maybe<CornerPosition>;
};

export type DoorCornersInput = {
  bottomLeft: CornerPositionInput;
  bottomRight: CornerPositionInput;
  doorTypeId: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  topLeft: CornerPositionInput;
  topRight: CornerPositionInput;
};

export type DoorLocation = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type DoorTypeFilterOption = {
  __typename?: 'DoorTypeFilterOption';
  description: Scalars['String']['output'];
  doorType: ProductType;
  svgImageUrl?: Maybe<Scalars['String']['output']>;
};

export type EmailLog = {
  __typename?: 'EmailLog';
  aws_message_id?: Maybe<Scalars['String']['output']>;
  body_html?: Maybe<Scalars['String']['output']>;
  body_text: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  provider: EmailProvider;
  provider_payload?: Maybe<Scalars['String']['output']>;
  status: EmailStatus;
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailLogFilter = {
  from?: InputMaybe<Scalars['String']['input']>;
  fromCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EmailStatus>;
  to?: InputMaybe<Scalars['String']['input']>;
  toCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EmailLogPaginationModel = {
  __typename?: 'EmailLogPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<EmailLog>>;
};

export enum EmailProvider {
  AwsSes = 'AWS_SES',
  Local = 'LOCAL'
}

export enum EmailStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type EventFilterInput = {
  appUserId?: InputMaybe<Scalars['String']['input']>;
  customerKeys?: InputMaybe<Scalars['String']['input']>;
  eventNames?: InputMaybe<Scalars['String']['input']>;
  exampleImageId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  productExternalId?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  userScenarioId?: InputMaybe<Scalars['String']['input']>;
};

export enum EventInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type EventsCountByDate = {
  __typename?: 'EventsCountByDate';
  count: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

/** An example image provided by us to show case the app without making a photo. */
export type ExampleImage = {
  __typename?: 'ExampleImage';
  /** The corners of the example image. */
  corners: Array<DoorCorners>;
  customData?: Maybe<Scalars['String']['output']>;
  doorType: ProductType;
  /** The uuid identifying the example image. */
  id: Scalars['String']['output'];
  /** The full sized image. */
  image: Image;
  /** The position of the light in the example image */
  lightPosition: LightPosition;
  /** Location and intensity of light sources */
  lightSourceParameters: Array<LightSourcesParameters>;
  /** The orientation of the example image */
  orientation: ImageOrientation;
  /** The shadow image of the example image */
  shadowImage?: Maybe<Image>;
  /** The shortId identifying the example image. */
  shortId: Scalars['String']['output'];
  /** A small thumbnail image which should be used to preview the example image in a list etc. */
  thumbnail: Image;
  usageCount: Scalars['Float']['output'];
};

export type ExampleImageOrderInput = {
  id: Scalars['String']['input'];
  order: Scalars['Float']['input'];
};

export type ExampleImageSet = {
  __typename?: 'ExampleImageSet';
  /** The uuid identifying the example image set. */
  id: Scalars['String']['output'];
  /** The name of the example image set. */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of the example image set. */
  nr: Scalars['Float']['output'];
  thumbnail?: Maybe<Image>;
};

export type ExampleImagesResponse = {
  __typename?: 'ExampleImagesResponse';
  horizontals: Array<ExampleImage>;
  verticals: Array<ExampleImage>;
};

export type File = {
  __typename?: 'File';
  /** The uuid identifying the file. */
  id: Scalars['String']['output'];
  /** The url to the image */
  url: Scalars['String']['output'];
};

/** Represents the filter context */
export type FilterContextInput = {
  /** The custom attributes the user selected */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** The door type the user selected, will default to the customers default door type if not set */
  doorTypeId?: InputMaybe<Scalars['String']['input']>;
  /** The selected options for each filter category */
  filterFor?: InputMaybe<Array<SelectedFilteCategoryOptions>>;
  onlyFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  /** The external id of the referral visual door */
  referralVisualDoorExternalId?: InputMaybe<Scalars['String']['input']>;
  /** The sorting id which should be used to sort the visual doors */
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** A product representing a door frame */
export type FrameProduct = Product & {
  __typename?: 'FrameProduct';
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']['output']>;
  /** The height of the door frame */
  height?: Maybe<Scalars['Float']['output']>;
  /** The uuid of the product */
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  /** The human readable name of the visual door */
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String']['output'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']['output']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']['output']>;
  showForAllDoors?: Maybe<Scalars['Boolean']['output']>;
  showForDoorTypes?: Maybe<Array<ProductType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']['output']>;
  /** The width of the door frame */
  width?: Maybe<Scalars['Float']['output']>;
};

export type GetEventCountsPerIntervalInput = {
  customerKey: Scalars['String']['input'];
  eventInterval: EventInterval;
  eventNames?: InputMaybe<Array<Scalars['String']['input']>>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
};

/** A hero filter represents a collection of category filter options which can be selected by the user via a single click on the hero image */
export type HeroFilterOption = {
  __typename?: 'HeroFilterOption';
  categoryOptionsToSelect?: Maybe<Array<CategoryOptionsToSelect>>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  /** The uuid identifying the image. */
  id: Scalars['String']['output'];
  /** The url to the image */
  url: Scalars['String']['output'];
};

export enum ImageButtonsArrangement {
  Line = 'LINE',
  Stacked = 'STACKED'
}

export enum ImageButtonsPlacement {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum ImageOrientation {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

/** A job represents an async operation such as exporting doors or importing images */
export type Job = {
  __typename?: 'Job';
  /** When the job was created */
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** Error message if the job failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the job finished */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  inputFile?: Maybe<File>;
  /** Optional log output of the job */
  logs?: Maybe<Scalars['String']['output']>;
  outputFile?: Maybe<File>;
  /** Optional payload passed to the job (as JSON string) */
  payload?: Maybe<Scalars['String']['output']>;
  /** Progress of the job in percentage */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Number of retries the job has attempted */
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the job started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the job */
  status: JobStatus;
  /** The type of the job */
  type: JobType;
  /** When the job was last updated */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type JobPaginationModel = {
  __typename?: 'JobPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<Job>>;
};

/** Current state of the job execution */
export enum JobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Type of the job (import/export, images, etc.) */
export enum JobType {
  ExportExampleImages = 'EXPORT_EXAMPLE_IMAGES',
  ExportProducts = 'EXPORT_PRODUCTS',
  ExportTrackingEvents = 'EXPORT_TRACKING_EVENTS',
  ExportVisualDoors = 'EXPORT_VISUAL_DOORS',
  ImportExampleImages = 'IMPORT_EXAMPLE_IMAGES',
  ImportProducts = 'IMPORT_PRODUCTS',
  ImportVisualDoors = 'IMPORT_VISUAL_DOORS'
}

export type JobsFilter = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<JobType>>;
};

export enum LightPosition {
  Center = 'CENTER',
  Left_1 = 'LEFT_1',
  Left_2 = 'LEFT_2',
  Right_1 = 'RIGHT_1',
  Right_2 = 'RIGHT_2'
}

/** Provide location and intensity of light sources */
export type LightSourcesParameters = {
  __typename?: 'LightSourcesParameters';
  intensity: Scalars['Float']['output'];
  location: Array<Scalars['Float']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  user: User;
};

export enum LogoPlacement {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Maintenance = {
  __typename?: 'Maintenance';
  customers: Array<Customer>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename?: 'MonetaryValue';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MonetaryValueInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateExampleImageSetsForCustomer: Scalars['Boolean']['output'];
  addTagToUserScenario: Scalars['Boolean']['output'];
  addVisualDoorToShadowProfile: Scalars['Boolean']['output'];
  assignMultipleVisualDoorsToProduct: Scalars['Boolean']['output'];
  assignProductToVisualDoor: Scalars['Boolean']['output'];
  changePassword: User;
  createCname: Scalars['Boolean']['output'];
  createCustomer: Customer;
  createExampleImageSet: ExampleImageSet;
  createJob: Job;
  createNewAppUser: AppUser;
  createNewExampleImage: ExampleImage;
  createNewUser: User;
  createOrUpdateShadowProfile: ShadowProfile;
  /**
   * Upload an image or use one of our example images to create a user scenario
   *  user scenario is only persisted for 4 days.
   */
  createUserScenario: CreateScenarioResponse;
  deactivateExampleImageSetsForCustomer: Scalars['Boolean']['output'];
  deleteCustomAttribute: Scalars['Boolean']['output'];
  deleteExampleImage: Scalars['Boolean']['output'];
  deleteExampleImageSet: Scalars['Boolean']['output'];
  deletePod: Scalars['String']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deleteProductType: Scalars['Boolean']['output'];
  deleteShadowImage: Scalars['Boolean']['output'];
  deleteShadowProfile: Scalars['Boolean']['output'];
  deleteTagFromUserScenario: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteUserScenarioForAppUser: Array<UserScenario>;
  deleteUsersScenario: Scalars['Boolean']['output'];
  deleteVisualDoor: Scalars['Boolean']['output'];
  duplicateExampleImagesForCustomer: Scalars['Boolean']['output'];
  forgotPasswordRequest: Scalars['Boolean']['output'];
  importProducts: Scalars['Boolean']['output'];
  login: LoginResponse;
  markVisualDoorAsFavorite: AppUser;
  /** Performs an initial order population */
  populateProductOrder: Scalars['Boolean']['output'];
  /** Performs an initial order population */
  populateVisualDoorOrder: Scalars['Boolean']['output'];
  /** Refine the position of the corners of a user scenario */
  refineCorners: UserScenario;
  regenerateShadowInpainting: Scalars['Boolean']['output'];
  removeVisualDoorFromShadowProfile: Scalars['Boolean']['output'];
  /** Create or update a custom attribute */
  saveCustomAttribute: CustomAttribute;
  saveCustomerConfig: CustomerConfig;
  saveMaintenance: Maintenance;
  saveProduct: Product;
  saveProductType: ProductType;
  saveVisualDoor: VisualDoor;
  setPassword: Scalars['Boolean']['output'];
  startPod: Scalars['String']['output'];
  stopPod: Scalars['String']['output'];
  toggleVisualDoorFavorite: Scalars['Boolean']['output'];
  trackEvent: Scalars['Boolean']['output'];
  unMarkVisualDoorAsFavorite: AppUser;
  unassignAllVisualDoorsForProduct: Scalars['Boolean']['output'];
  unassignProductFromVisualDoor: Scalars['Boolean']['output'];
  updateCustomerActivation: Scalars['Boolean']['output'];
  updateDefinedOrdersOfProducts: Scalars['Boolean']['output'];
  updateExampleImage: ExampleImage;
  updateExampleImageOrder: Scalars['Boolean']['output'];
  updateExampleImageSet: ExampleImageSet;
  updateOrderOfVisualDoors: Scalars['Boolean']['output'];
  uploadConfigImage: Scalars['String']['output'];
  uploadNewExampleImageImage: ExampleImage;
  /** Warms up the aws-lambdas to avoid cold starts on future requests */
  warmUpLambdas: Scalars['Boolean']['output'];
};


export type MutationActivateExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String']['input'];
};


export type MutationAddTagToUserScenarioArgs = {
  tag: Scalars['String']['input'];
  userScenarioId: Scalars['String']['input'];
};


export type MutationAddVisualDoorToShadowProfileArgs = {
  shadowProfileId: Scalars['Int']['input'];
  visualDoorId: Scalars['String']['input'];
};


export type MutationAssignMultipleVisualDoorsToProductArgs = {
  customerKey: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  visualDoorExternalIds: Array<Scalars['String']['input']>;
};


export type MutationAssignProductToVisualDoorArgs = {
  productId: Scalars['String']['input'];
  visualDoorId: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateCnameArgs = {
  key: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateExampleImageSetArgs = {
  customerKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateJobArgs = {
  parameters: CreateJobInput;
};


export type MutationCreateNewExampleImageArgs = {
  customerKey: Scalars['String']['input'];
  doorTypeId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  setNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateNewUserArgs = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: Role;
};


export type MutationCreateOrUpdateShadowProfileArgs = {
  customerKey: Scalars['String']['input'];
  parameters: CreateOrUpdateShadowProfileInputArguments;
};


export type MutationCreateUserScenarioArgs = {
  parameters: CreateUserScenarioParameters;
};


export type MutationDeactivateExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String']['input'];
};


export type MutationDeleteCustomAttributeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExampleImageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExampleImageSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePodArgs = {
  podId: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShadowImageArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationDeleteShadowProfileArgs = {
  shadowProfileId: Scalars['Int']['input'];
};


export type MutationDeleteTagFromUserScenarioArgs = {
  tag: Scalars['String']['input'];
  userScenarioId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteUserScenarioForAppUserArgs = {
  userScenarioShortId: Scalars['String']['input'];
};


export type MutationDeleteUsersScenarioArgs = {
  userScenarioId: Scalars['String']['input'];
};


export type MutationDeleteVisualDoorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDuplicateExampleImagesForCustomerArgs = {
  destinationCustomerKey: Scalars['String']['input'];
  destinationDoorTypeId: Scalars['String']['input'];
  sourceCustomerKey: Scalars['String']['input'];
  sourceDoorTypeId: Scalars['String']['input'];
};


export type MutationForgotPasswordRequestArgs = {
  email: Scalars['String']['input'];
};


export type MutationImportProductsArgs = {
  customerKey: Scalars['String']['input'];
  deleteAllExistingProducts?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['Upload']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkVisualDoorAsFavoriteArgs = {
  visualDoorId: Scalars['String']['input'];
};


export type MutationPopulateProductOrderArgs = {
  customerKeys: Array<Scalars['String']['input']>;
};


export type MutationPopulateVisualDoorOrderArgs = {
  customerKeys: Array<Scalars['String']['input']>;
};


export type MutationRefineCornersArgs = {
  corners: Array<DoorCornersInput>;
  customData?: InputMaybe<Scalars['String']['input']>;
  userScenarioId: Scalars['String']['input'];
};


export type MutationRegenerateShadowInpaintingArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationRemoveVisualDoorFromShadowProfileArgs = {
  shadowProfileId: Scalars['Int']['input'];
  visualDoorId: Scalars['String']['input'];
};


export type MutationSaveCustomAttributeArgs = {
  customerKey: Scalars['String']['input'];
  input: CustomAttributeSaveInput;
};


export type MutationSaveCustomerConfigArgs = {
  input: SaveCustomerConfigInput;
};


export type MutationSaveMaintenanceArgs = {
  customerKeys: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSaveProductArgs = {
  input: SaveProductInput;
};


export type MutationSaveProductTypeArgs = {
  input: SaveProductTypeInput;
};


export type MutationSaveVisualDoorArgs = {
  customerKey: Scalars['String']['input'];
  customerSpecificParameters?: InputMaybe<CustomerSpecificParameters>;
  parameters: CreateVisualDoorParameters;
  shadowProfileId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationStartPodArgs = {
  podId: Scalars['String']['input'];
};


export type MutationStopPodArgs = {
  podId: Scalars['String']['input'];
};


export type MutationToggleVisualDoorFavoriteArgs = {
  visualDoorId: Scalars['String']['input'];
};


export type MutationTrackEventArgs = {
  event: TrackEventInput;
};


export type MutationUnMarkVisualDoorAsFavoriteArgs = {
  visualDoorId: Scalars['String']['input'];
};


export type MutationUnassignAllVisualDoorsForProductArgs = {
  productId: Scalars['String']['input'];
};


export type MutationUnassignProductFromVisualDoorArgs = {
  productId: Scalars['String']['input'];
  visualDoorId: Scalars['String']['input'];
};


export type MutationUpdateCustomerActivationArgs = {
  active: Scalars['Boolean']['input'];
  customerKey: Scalars['String']['input'];
};


export type MutationUpdateDefinedOrdersOfProductsArgs = {
  productType: Scalars['String']['input'];
  productsWithOrder: Array<ProductWithOrder>;
};


export type MutationUpdateExampleImageArgs = {
  corners: Array<DoorCornersInput>;
  customData?: InputMaybe<Scalars['String']['input']>;
  doorTypeId: Scalars['String']['input'];
  exampleImageId: Scalars['String']['input'];
  lightPosition: LightPosition;
};


export type MutationUpdateExampleImageOrderArgs = {
  exampleImages: Array<ExampleImageOrderInput>;
};


export type MutationUpdateExampleImageSetArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nr: Scalars['Int']['input'];
};


export type MutationUpdateOrderOfVisualDoorsArgs = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  visualDoorExternalIds: Scalars['String']['input'];
};


export type MutationUploadConfigImageArgs = {
  configId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  fileType: Scalars['String']['input'];
};


export type MutationUploadNewExampleImageImageArgs = {
  exampleImageId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  fileType: Scalars['String']['input'];
};

/** PageInfo */
export type PageInfoModel = {
  __typename?: 'PageInfoModel';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalResults: Scalars['Int']['output'];
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<Product>>;
};

export enum PaginationMode {
  Cursor = 'CURSOR',
  Page = 'PAGE'
}

export type PaginationModel = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  mode: PaginationMode;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PasswordResetToken = {
  __typename?: 'PasswordResetToken';
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** The product interface with the common fields for all products */
export type Product = {
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']['output']>;
  /** The uuid of the product */
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  /** The human readable name of the visual door */
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String']['output'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']['output']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']['output']>;
  showForAllDoors?: Maybe<Scalars['Boolean']['output']>;
  showForDoorTypes?: Maybe<Array<ProductType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']['output']>;
};

export type ProductFilter = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only deliver products for this product type */
  productType?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Only deliver products for this visual door */
  visualDoorId?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductLinkType {
  NewTab = 'NEW_TAB',
  PopUp = 'POP_UP',
  SameTab = 'SAME_TAB'
}

export type ProductType = {
  __typename?: 'ProductType';
  cornerDetectionModel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** Columns to show in door range panel */
  doorRangePanelColumnCount?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<SelectedSvg>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  photoAssistanceOverlay?: Maybe<SelectedSvg>;
  /** Mapped external door types */
  sourceType?: Maybe<Array<Scalars['String']['output']>>;
  /** JSON-encoded translations */
  translations?: Maybe<Scalars['String']['output']>;
  type: ProductTypeType;
  typeDetectionDeciderRatio?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductTypeFilterInput = {
  customerKey: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductTypeType>;
};

/** Either a general product type or a door type */
export enum ProductTypeType {
  DoorType = 'DOOR_TYPE',
  ProductType = 'PRODUCT_TYPE'
}

export type ProductWithOrder = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  findJobs: JobPaginationModel;
  findProductTypes: Array<ProductType>;
  getAllCustomer: Array<Customer>;
  getAllShadowProfiles: Array<ShadowProfile>;
  getAllUserScenarios: UserScenarioPaginationModel;
  getAllUsers: Array<User>;
  getAppUser: AppUser;
  getAppUserByShortId?: Maybe<AppUser>;
  getCountsPerDay: Array<UserScenarioCountByDay>;
  /** Delivers the customer for the given key. */
  getCustomer: Customer;
  getDefaultCorners: DoorCorners;
  getEmailLogs: EmailLogPaginationModel;
  getEvent: TrackingEvent;
  getEventCountsPerInterval: Array<EventsCountByDate>;
  getEvents: TrackingEventPaginationModel;
  getEventsCount: Scalars['Int']['output'];
  /** Delivers the example image for the given exampleId */
  getExampleImage: ExampleImage;
  /** Delivers the example image for the given short id */
  getExampleImageByShortId: ExampleImage;
  getExampleImageSetByNumber: ExampleImageSet;
  getExampleImageSetsForCustomer: Array<ExampleImageSet>;
  /** Delivers example images for the customer if a user has no image at hand. */
  getExampleImages: ExampleImagesResponse;
  getFavoriteCount: Scalars['Float']['output'];
  getJob: Job;
  getMaintenance?: Maybe<Maintenance>;
  getPaginatedProducts: PaginatedProducts;
  getPasswordResetTokenInformation: PasswordResetToken;
  getProduct: Product;
  getProductByExternaldId?: Maybe<Product>;
  getProductType: ProductType;
  getShadowProfile: ShadowProfile;
  /** Delivers the user scenario for the given UUID */
  getUserScenario: UserScenario;
  /** Delivers the user scenario for the given short id */
  getUserScenarioByShortId: UserScenario;
  /** Get the visual door for the given uuid */
  getVisualDoor: VisualDoor;
  /** Get the visual door for a given customer and external id */
  getVisualDoorForExternalIdAndCustomer: VisualDoor;
  /** Delivers the visual doors provided by the customer. */
  getVisualDoors: VisualDoorPaginationModel;
  getVisualDoorsFilterOptions?: Maybe<VisualDoorFilterOptions>;
  getVisualDoorsPaginated: VisualDoorPaginationModel;
  healthCheck: Scalars['String']['output'];
  listPods: Array<RunpodPod>;
  me: User;
};


export type QueryFindJobsArgs = {
  filter: JobsFilter;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryFindProductTypesArgs = {
  filter: ProductTypeFilterInput;
};


export type QueryGetAllCustomerArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAllShadowProfilesArgs = {
  customerKey: Scalars['String']['input'];
};


export type QueryGetAllUserScenariosArgs = {
  filter?: InputMaybe<UserScenariosFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetAppUserByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type QueryGetCountsPerDayArgs = {
  customerKey: Scalars['String']['input'];
  daysCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCustomerArgs = {
  customerKey: Scalars['String']['input'];
};


export type QueryGetDefaultCornersArgs = {
  doorTypeId: Scalars['String']['input'];
  imageHeight: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
};


export type QueryGetEmailLogsArgs = {
  filter?: InputMaybe<EmailLogFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetEventCountsPerIntervalArgs = {
  arg: GetEventCountsPerIntervalInput;
};


export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventFilterInput>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetEventsCountArgs = {
  filter?: InputMaybe<EventFilterInput>;
};


export type QueryGetExampleImageArgs = {
  exampleImageId: Scalars['String']['input'];
};


export type QueryGetExampleImageByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type QueryGetExampleImageSetByNumberArgs = {
  customerKey: Scalars['String']['input'];
  nr: Scalars['Int']['input'];
};


export type QueryGetExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String']['input'];
};


export type QueryGetExampleImagesArgs = {
  customerKey: Scalars['String']['input'];
  doorTypeId?: InputMaybe<Scalars['String']['input']>;
  setNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFavoriteCountArgs = {
  customerKey: Scalars['String']['input'];
};


export type QueryGetJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetPaginatedProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetPasswordResetTokenInformationArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetProductByExternaldIdArgs = {
  customerKey: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};


export type QueryGetProductTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetShadowProfileArgs = {
  shadowProfileId: Scalars['Float']['input'];
};


export type QueryGetUserScenarioArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUserScenarioByShortIdArgs = {
  shortId: Scalars['String']['input'];
};


export type QueryGetVisualDoorArgs = {
  visualDoorId: Scalars['String']['input'];
};


export type QueryGetVisualDoorForExternalIdAndCustomerArgs = {
  customerKey: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};


export type QueryGetVisualDoorsArgs = {
  customerKey: Scalars['String']['input'];
  filter?: InputMaybe<FilterContextInput>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetVisualDoorsFilterOptionsArgs = {
  filterInput?: InputMaybe<FilterContextInput>;
};


export type QueryGetVisualDoorsPaginatedArgs = {
  filter?: InputMaybe<VisualDoorsPaginationFilter>;
  pagination?: InputMaybe<PaginationModel>;
};

export enum Role {
  Admin = 'Admin',
  CustomerAdmin = 'CustomerAdmin'
}

export type RunpodPod = {
  __typename?: 'RunpodPod';
  costPerHr: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  desiredStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageName: Scalars['String']['output'];
  lastStartedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uptimeSeconds: Scalars['Int']['output'];
};

export type SaveCustomerConfigInput = {
  allowClippedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleDoors?: InputMaybe<Scalars['Boolean']['input']>;
  alwaysShowImageButtons?: InputMaybe<Scalars['Boolean']['input']>;
  colors?: InputMaybe<ColorInput>;
  configUuid: Scalars['String']['input'];
  createShadowInpaintingOnUserScenarioUpload?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDoorTypeId: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  disableProductOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  disableVisualDoorsOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableDoorTypeDropdownSelection?: InputMaybe<Scalars['Boolean']['input']>;
  enableShadowInpainting?: InputMaybe<Scalars['Boolean']['input']>;
  enableVisualDoorsSearch?: InputMaybe<Scalars['Boolean']['input']>;
  enabledProducts?: InputMaybe<Scalars['Boolean']['input']>;
  enabledShadowInpaintingOnExampleImages?: InputMaybe<Scalars['Boolean']['input']>;
  enabledShadowProfiles: Scalars['Boolean']['input'];
  gtmTag?: InputMaybe<Scalars['String']['input']>;
  hideDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideFlipButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideRefineButtonUnderImage?: InputMaybe<Scalars['Boolean']['input']>;
  hideShareButton?: InputMaybe<Scalars['Boolean']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  imageButtonsArrangement: ImageButtonsArrangement;
  imageButtonsPlacement: ImageButtonsPlacement;
  logoPlacement: LogoPlacement;
  logoSvg?: InputMaybe<Scalars['String']['input']>;
  mainDoorTypeFilterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productLinkType: ProductLinkType;
  shopLinkOverwrite?: InputMaybe<Scalars['String']['input']>;
  showCustomAttributesFilter?: InputMaybe<Scalars['Boolean']['input']>;
  showDoorVisionBranding: Scalars['Boolean']['input'];
  showGlassLayerInVisualization: Scalars['Boolean']['input'];
  showRefineLayoutAfterUpload: Scalars['Boolean']['input'];
  showUserScenarioGraphsInOverview: Scalars['Boolean']['input'];
  showUserScenariosCounts: Scalars['Boolean']['input'];
  showVisitHomepageButton?: InputMaybe<Scalars['Boolean']['input']>;
  supportedProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<Scalars['String']['input']>;
  useFavoritesList: Scalars['Boolean']['input'];
};

export type SaveProductInput = {
  customData?: InputMaybe<Scalars['String']['input']>;
  customerKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  externalIds: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Float']['input'];
  price?: InputMaybe<MonetaryValueInput>;
  productType: Scalars['String']['input'];
  renderingContextFillStyle?: InputMaybe<Scalars['String']['input']>;
  renderingContextFilter?: InputMaybe<Scalars['String']['input']>;
  showForAllDoors?: InputMaybe<Scalars['Boolean']['input']>;
  showForDoorTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailImage?: InputMaybe<Scalars['Upload']['input']>;
  visualisationImage?: InputMaybe<Scalars['Upload']['input']>;
  visualisationLayer?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProductTypeInput = {
  cornerDetectionModel?: InputMaybe<Scalars['String']['input']>;
  customerKey: Scalars['String']['input'];
  doorRangePanelColumnCount?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSelectionKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  photoAssistanceOverlay?: InputMaybe<Scalars['String']['input']>;
  photoAssistanceOverlaySelectionKey?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductTypeType>;
  typeDetectionDeciderRatio?: InputMaybe<Scalars['Float']['input']>;
};

export enum ScenarioType {
  Example = 'EXAMPLE',
  User = 'USER'
}

/** Represents the filters the user selected */
export type SelectedFilteCategoryOptions = {
  /** The filter category id */
  categoryId: Scalars['String']['input'];
  /** The array of filter option ids the user selected for this filter category */
  selectedOptionIds: Array<Scalars['String']['input']>;
};

export type SelectedSvg = {
  __typename?: 'SelectedSvg';
  selectedKey: Scalars['String']['output'];
  svg: Scalars['String']['output'];
};

export type ShadowImagesInput = {
  /** File upload if the user uses an own photo */
  image?: InputMaybe<Scalars['Upload']['input']>;
  lightPosition: LightPosition;
};

export type ShadowProfile = {
  __typename?: 'ShadowProfile';
  customer: Customer;
  eastShadowImage?: Maybe<Image>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  northEastShadowImage?: Maybe<Image>;
  northShadowImage?: Maybe<Image>;
  northWestShadowImage?: Maybe<Image>;
  title: Scalars['String']['output'];
  visualDoors: Array<VisualDoor>;
  visualDoorsCount: Scalars['Float']['output'];
  westShadowImage?: Maybe<Image>;
};

export type TrackEventInput = {
  appUserShortId?: InputMaybe<Scalars['String']['input']>;
  customerKey?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  exampleScenarioId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productExternalId?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  scenarioType?: InputMaybe<ScenarioType>;
};

export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  appUser?: Maybe<AppUser>;
  customer?: Maybe<Customer>;
  data?: Maybe<Scalars['String']['output']>;
  exampleImage?: Maybe<ExampleImage>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trackedAt: Scalars['DateTime']['output'];
  userScenario?: Maybe<UserScenario>;
  visualDoor?: Maybe<VisualDoor>;
};

export type TrackingEventPaginationModel = {
  __typename?: 'TrackingEventPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<TrackingEvent>>;
};

export type User = {
  __typename?: 'User';
  customer?: Maybe<Customer>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  role: Role;
};

/** A User scenario represents an uploaded and analysed image from the user */
export type UserScenario = {
  __typename?: 'UserScenario';
  /** The corners of the door in the image. Can be update with the mutation `refineCorners` */
  corners: Array<DoorCorners>;
  /** The original corners of the door in the image detected by our image analyser */
  cornersOriginal?: Maybe<Array<DoorCorners>>;
  createdAt: Scalars['DateTime']['output'];
  customData?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  /** The debug information for this user scenario */
  debugInformation?: Maybe<Array<UserScenarioDebugInformation>>;
  doorType: ProductType;
  /** Determines if the user scenario was created by using an example image */
  exampleImageUsed: Scalars['Boolean']['output'];
  /** The uuid of this user scenario */
  id: Scalars['String']['output'];
  /**
   * The actual image of this user scenario.
   * This can ether be an uploaded image or one of our example images.
   */
  image: Image;
  isWaitingForVisualizationImprovement?: Maybe<Scalars['Boolean']['output']>;
  /** The position of the light in the user image */
  lightPosition: LightPosition;
  /** Location and intensity of light sources */
  lightSourceParameters: Array<LightSourcesParameters>;
  nextUserScenario?: Maybe<UserScenario>;
  /** The orientation of the user scenario image */
  orientation: ImageOrientation;
  previousUserScenario?: Maybe<UserScenario>;
  /** The shadow image of the user scenario */
  shadowImage?: Maybe<Image>;
  /** The shortId of this user scenario */
  shortId: Scalars['String']['output'];
  /** The tags for this user scenario */
  tags: Array<Scalars['String']['output']>;
  thumbnailImage: Image;
};

export type UserScenarioCountByDay = {
  __typename?: 'UserScenarioCountByDay';
  all: Scalars['Float']['output'];
  countExampleImages: Scalars['Float']['output'];
  countUploads: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

/** The debug information for the user scenario */
export type UserScenarioDebugInformation = {
  __typename?: 'UserScenarioDebugInformation';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserScenarioPaginationModel = {
  __typename?: 'UserScenarioPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<UserScenario>>;
};

export type UserScenariosFilter = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Show only user scenarios where image analyse delivered an error */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show only user scenarios where the user actually uploaded an image */
  onlyUploadedImages?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A visual door is a door model provided by the customer */
export type VisualDoor = {
  __typename?: 'VisualDoor';
  customAttributes?: Maybe<Array<CustomAttributeValue>>;
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']['output']>;
  directDoorsProperties?: Maybe<DirectDoorsVisualDoorParameters>;
  doorType: ProductType;
  /** Determines if the visual doors is enabled in the visualisation */
  enabled: Scalars['Boolean']['output'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']['output']>;
  /** Delivers the shadow image for the given lighting position */
  getShadowImage?: Maybe<Image>;
  /** The uuid of the visual door */
  id: Scalars['String']['output'];
  /** The full image of the visual door */
  image: Image;
  isFavorite: Scalars['Boolean']['output'];
  /** The human readable name of the visual door */
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  shadowProfile?: Maybe<ShadowProfile>;
  /** The link which should be opened when the user clicks shop now */
  showNowLink: Scalars['String']['output'];
  /** The human readable slug of the visual door */
  slug: Scalars['String']['output'];
  /** A small thumbnail image which should be used to preview the visual door in lists etc. */
  thumbnail: Image;
};


/** A visual door is a door model provided by the customer */
export type VisualDoorGetShadowImageArgs = {
  lightPosition: LightPosition;
};

/** A filter category with the options */
export type VisualDoorFilterCategory = {
  __typename?: 'VisualDoorFilterCategory';
  /** The description of the filter category */
  description?: Maybe<Scalars['String']['output']>;
  /** Defines if this filter category should be enabled */
  enabled: Scalars['Boolean']['output'];
  /** The id of the filter category */
  id: Scalars['String']['output'];
  /** The name of the filter category */
  name: Scalars['String']['output'];
  /** The possible options which can be selected for this category */
  options: Array<VisualDoorFilterCategoryOption>;
};

/** A filter category with the options */
export type VisualDoorFilterCategoryOption = {
  __typename?: 'VisualDoorFilterCategoryOption';
  /** The count of visual doors which are including in this filter category option */
  count?: Maybe<Scalars['Float']['output']>;
  /** The name of the category filter option which can be selected. */
  description: Scalars['String']['output'];
  /** The id of the category options */
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
};

/** The filter options for the visual door */
export type VisualDoorFilterOptions = {
  __typename?: 'VisualDoorFilterOptions';
  /** The possible categories which can be used to filter the visual doors */
  categories?: Maybe<Array<VisualDoorFilterCategory>>;
  doorTypeOptions?: Maybe<Array<DoorTypeFilterOption>>;
  heroFilterOptions?: Maybe<Array<HeroFilterOption>>;
  /** Defines if the door type filters should be shown as a dropdown option */
  showDoorTypeFilterAsDropdown?: Maybe<Scalars['Boolean']['output']>;
  /** The possible sorting options */
  sortingOptions?: Maybe<Array<VisualDoorSortingOption>>;
};

export type VisualDoorPaginationModel = {
  __typename?: 'VisualDoorPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<VisualDoor>>;
};

export enum VisualDoorProvider {
  Internal = 'INTERNAL',
  Shopify = 'SHOPIFY',
  Shopware = 'SHOPWARE'
}

/** A filter category with the options */
export type VisualDoorSortingOption = {
  __typename?: 'VisualDoorSortingOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VisualDoorsPaginationFilter = {
  customerKey?: InputMaybe<Scalars['String']['input']>;
  doorTypeId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  onlyWithoutShadowProfile?: InputMaybe<Scalars['Boolean']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  /** Search term can include the visual door name or external id */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type GetMaintenanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceQuery = { __typename?: 'Query', getMaintenance?: { __typename?: 'Maintenance', title: string, description: string, customers: Array<{ __typename?: 'Customer', id: string, name: string, key: string }> } | null };

export type TrackEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
  customerKey?: InputMaybe<Scalars['String']['input']>;
  scenarioType?: InputMaybe<ScenarioType>;
  appUserShortId?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  exampleScenarioId?: InputMaybe<Scalars['String']['input']>;
  productExternalId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackEventMutation = { __typename?: 'Mutation', trackEvent: boolean };

export type GetCustomerConfigQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
}>;


export type GetCustomerConfigQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', name: string, homepageUrl?: string | null, isInMaintenance?: boolean | null, config: { __typename?: 'CustomerConfig', logoPath?: string | null, defaultLanguage: string, translationsPath: string, useFavoritesList: boolean, showDoorVisionBranding: boolean, showRefineLayoutAfterUpload: boolean, productLinkType: ProductLinkType, enabledShadowProfiles: boolean, showGlassLayerInVisualization: boolean, shopLinkOverwrite?: string | null, gtmTag?: string | null, enabledExampleImageSets?: boolean | null, allowMultipleDoors?: boolean | null, allowClippedCorners?: boolean | null, supportedProductTypes?: Array<string> | null, enableShadowInpainting?: boolean | null, enabledProducts?: boolean | null, hideShareButton?: boolean | null, enableDoorTypeDropdownSelection?: boolean | null, showCustomAttributesFilter?: boolean | null, hideDownloadButton?: boolean | null, hideFlipButton?: boolean | null, hideRefineButtonUnderImage?: boolean | null, showVisitHomepageButton?: boolean | null, alwaysShowImageButtons?: boolean | null, logoPlacement: LogoPlacement, imageButtonsArrangement: ImageButtonsArrangement, imageButtonsPlacement: ImageButtonsPlacement, enableVisualDoorsSearch?: boolean | null, mainDoorTypeFilter?: Array<{ __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }> | null, defaultDoorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, supportedDoorTypes?: Array<{ __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }> | null, colors?: { __typename?: 'CustomerColor', primary?: string | null, primaryText?: string | null, uploadPanelText?: string | null, uploadPanelBackground?: string | null, imageButtonsBackground?: string | null, imageButtonsText?: string | null } | null } } };

export type DoorFragment = { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } };

export type DoorWithShadowProfilesFragment = { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, shadowProfile?: { __typename?: 'ShadowProfile', id: number, northShadowImage?: { __typename?: 'Image', id: string, url: string } | null, westShadowImage?: { __typename?: 'Image', id: string, url: string } | null, eastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northEastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northWestShadowImage?: { __typename?: 'Image', id: string, url: string } | null } | null, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } };

export type GetVisualDoorsStateServiceQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
  filter?: InputMaybe<FilterContextInput>;
  paginationModel?: InputMaybe<PaginationModel>;
}>;


export type GetVisualDoorsStateServiceQuery = { __typename?: 'Query', getVisualDoors: { __typename?: 'VisualDoorPaginationModel', paginationMode: PaginationMode, cursorBasedPaginationInfo?: { __typename?: 'CursorBasedPageInfoModel', hasNextPage: boolean, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } | null, pageInfo?: { __typename?: 'PageInfoModel', page: number, pageSize: number, totalResults: number, totalPages: number } | null, results?: Array<{ __typename?: 'VisualDoor', id: string, externalIds: Array<string>, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } }> | null } };

export type GetVisualDoorQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type GetVisualDoorQuery = { __typename?: 'Query', getVisualDoorForExternalIdAndCustomer: { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, shadowProfile?: { __typename?: 'ShadowProfile', id: number, northShadowImage?: { __typename?: 'Image', id: string, url: string } | null, westShadowImage?: { __typename?: 'Image', id: string, url: string } | null, eastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northEastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northWestShadowImage?: { __typename?: 'Image', id: string, url: string } | null } | null, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } } };

export type CountFavoritesQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
}>;


export type CountFavoritesQuery = { __typename?: 'Query', getFavoriteCount: number };

export type ToggleVisualDoorFavoriteMutationVariables = Exact<{
  visualDoorId: Scalars['String']['input'];
}>;


export type ToggleVisualDoorFavoriteMutation = { __typename?: 'Mutation', toggleVisualDoorFavorite: boolean };

export type GetVisualDoorsFilterOptionsQueryVariables = Exact<{
  filter?: InputMaybe<FilterContextInput>;
}>;


export type GetVisualDoorsFilterOptionsQuery = { __typename?: 'Query', getVisualDoorsFilterOptions?: { __typename?: 'VisualDoorFilterOptions', heroFilterOptions?: Array<{ __typename?: 'HeroFilterOption', imageUrl: string, title: string, description?: string | null, categoryOptionsToSelect?: Array<{ __typename?: 'CategoryOptionsToSelect', categoryId: string, selectAllOptions?: boolean | null, optionsToSelect?: Array<string> | null }> | null }> | null, doorTypeOptions?: Array<{ __typename?: 'DoorTypeFilterOption', description: string, svgImageUrl?: string | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null } }> | null, sortingOptions?: Array<{ __typename?: 'VisualDoorSortingOption', id: string, name: string }> | null, categories?: Array<{ __typename?: 'VisualDoorFilterCategory', id: string, name: string, enabled: boolean, description?: string | null, options: Array<{ __typename?: 'VisualDoorFilterCategoryOption', id: string, description: string, count?: number | null, imageUrl?: string | null }> }> | null } | null };

export type SmallProductTypeFragment = { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null };

export type GetProductQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
  customerKey: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProductByExternaldId?: { __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | null };

export type FrameProductFragment = { __typename?: 'FrameProduct', width?: number | null, height?: number | null };

type Product_BasicProduct_Fragment = { __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null };

type Product_FrameProduct_Fragment = { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null };

export type ProductFragment = Product_BasicProduct_Fragment | Product_FrameProduct_Fragment;

export type GetPaginatedProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<PaginationModel>;
}>;


export type GetPaginatedProductsQuery = { __typename?: 'Query', getPaginatedProducts: { __typename: 'PaginatedProducts', cursorBasedPaginationInfo?: { __typename?: 'CursorBasedPageInfoModel', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage?: boolean | null } | null, results?: Array<{ __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null }> | null } };

export type GetUserScenariosForAppUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserScenariosForAppUserQuery = { __typename?: 'Query', getAppUser: { __typename?: 'AppUser', id: string, getUserScenarios: Array<{ __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } }> } };

export type DeleteUserScenarioForAppUserMutationVariables = Exact<{
  userScenarioId: Scalars['String']['input'];
}>;


export type DeleteUserScenarioForAppUserMutation = { __typename?: 'Mutation', deleteUserScenarioForAppUser: Array<{ __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } }> };

export type DoorCornersFragment = { __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } };

export type GetExampleImagesQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
  doorTypeId: Scalars['String']['input'];
  setNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExampleImagesQuery = { __typename?: 'Query', getExampleImages: { __typename?: 'ExampleImagesResponse', verticals: Array<{ __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, customData?: string | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } }>, horizontals: Array<{ __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, customData?: string | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } }> } };

export type ExampleScenarioFragment = { __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, customData?: string | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } };

export type GetDefaultCornersQueryVariables = Exact<{
  imageWidth: Scalars['Float']['input'];
  imageHeight: Scalars['Float']['input'];
  doorTypeId: Scalars['String']['input'];
}>;


export type GetDefaultCornersQuery = { __typename?: 'Query', getDefaultCorners: { __typename?: 'DoorCorners', index: number, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } } };

export type UpdateCornersMutationVariables = Exact<{
  userScenarioId: Scalars['String']['input'];
  corners: Array<DoorCornersInput> | DoorCornersInput;
  customData?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCornersMutation = { __typename?: 'Mutation', refineCorners: { __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } };

export type CreateUserScenarioFromUploadMutationVariables = Exact<{
  createUserScenarioParameters: CreateUserScenarioParameters;
}>;


export type CreateUserScenarioFromUploadMutation = { __typename?: 'Mutation', createUserScenario: { __typename?: 'CreateScenarioResponse', showCornerRefinement: boolean, userScenario: { __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } } };

export type GetUserScenarioByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type GetUserScenarioByShortIdQuery = { __typename?: 'Query', getUserScenarioByShortId: { __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } };

export type UserScenarioFragment = { __typename?: 'UserScenario', id: string, shortId: string, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, corners: Array<{ __typename?: 'DoorCorners', index: number, hasClippedCorners: boolean, doorType: { __typename?: 'ProductType', id: string, type: ProductTypeType, key: string, translations?: string | null, doorRangePanelColumnCount?: number | null, icon?: { __typename?: 'SelectedSvg', svg: string } | null }, topLeftBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeftRight?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightBottom?: { __typename?: 'CornerPosition', x: number, y: number } | null, topRightLeft?: { __typename?: 'CornerPosition', x: number, y: number } | null, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } };

export type CreateNewAppUserMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateNewAppUserMutation = { __typename?: 'Mutation', createNewAppUser: { __typename?: 'AppUser', id: string } };

export type GetUserQueryVariables = Exact<{
  customerKey: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', name: string, config: { __typename?: 'CustomerConfig', logoPath?: string | null, defaultLanguage: string, translationsPath: string, useFavoritesList: boolean, showDoorVisionBranding: boolean } } };

export const SmallProductTypeFragmentDoc = gql`
    fragment SmallProductType on ProductType {
  id
  type
  key
  translations
  doorRangePanelColumnCount
  icon {
    svg
  }
}
    `;
export const DoorFragmentDoc = gql`
    fragment Door on VisualDoor {
  id
  externalIds
  doorType {
    ...SmallProductType
  }
  name
  customData
  price {
    currency
    value
  }
  showNowLink
  slug
  thumbnail {
    url
  }
  image {
    url
  }
  isFavorite
}
    ${SmallProductTypeFragmentDoc}`;
export const DoorWithShadowProfilesFragmentDoc = gql`
    fragment DoorWithShadowProfiles on VisualDoor {
  id
  externalIds
  doorType {
    ...SmallProductType
  }
  name
  customData
  shadowProfile {
    id
    northShadowImage {
      id
      url
    }
    westShadowImage {
      id
      url
    }
    eastShadowImage {
      id
      url
    }
    northEastShadowImage {
      id
      url
    }
    northWestShadowImage {
      id
      url
    }
  }
  price {
    currency
    value
  }
  showNowLink
  slug
  thumbnail {
    url
  }
  image {
    url
  }
  isFavorite
}
    ${SmallProductTypeFragmentDoc}`;
export const FrameProductFragmentDoc = gql`
    fragment FrameProduct on FrameProduct {
  width
  height
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  __typename
  id
  externalIds
  name
  price {
    value
    currency
  }
  link
  enabled
  customData
  productType
  visualisationLayer
  renderingContextFilter
  renderingContextFillStyle
  visualisationImage {
    id
    url
  }
  thumbnailImage {
    id
    url
  }
  ... on FrameProduct {
    ...FrameProduct
  }
}
    ${FrameProductFragmentDoc}`;
export const DoorCornersFragmentDoc = gql`
    fragment DoorCorners on DoorCorners {
  index
  doorType {
    ...SmallProductType
  }
  hasClippedCorners
  topLeftBottom {
    x
    y
  }
  topLeftRight {
    x
    y
  }
  topRightBottom {
    x
    y
  }
  topRightLeft {
    x
    y
  }
  topLeft {
    x
    y
  }
  topRight {
    x
    y
  }
  bottomLeft {
    x
    y
  }
  bottomRight {
    x
    y
  }
}
    ${SmallProductTypeFragmentDoc}`;
export const ExampleScenarioFragmentDoc = gql`
    fragment ExampleScenario on ExampleImage {
  id
  shortId
  lightPosition
  doorType {
    ...SmallProductType
  }
  customData
  shadowImage {
    id
    url
  }
  corners {
    ...DoorCorners
  }
  lightSourceParameters {
    intensity
    location
  }
  image {
    id
    url
  }
  thumbnail {
    id
    url
  }
}
    ${SmallProductTypeFragmentDoc}
${DoorCornersFragmentDoc}`;
export const UserScenarioFragmentDoc = gql`
    fragment UserScenario on UserScenario {
  id
  shortId
  doorType {
    ...SmallProductType
  }
  customData
  lightPosition
  isWaitingForVisualizationImprovement
  corners {
    ...DoorCorners
  }
  lightSourceParameters {
    intensity
    location
  }
  shadowImage {
    id
    url
  }
  image {
    id
    url
  }
  thumbnailImage {
    id
    url
  }
}
    ${SmallProductTypeFragmentDoc}
${DoorCornersFragmentDoc}`;
export const GetMaintenanceDocument = gql`
    query GetMaintenance {
  getMaintenance {
    title
    description
    customers {
      id
      name
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaintenanceGQL extends Apollo.Query<GetMaintenanceQuery, GetMaintenanceQueryVariables> {
    override document = GetMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrackEventDocument = gql`
    mutation TrackEvent($name: String!, $customerKey: String, $scenarioType: ScenarioType, $appUserShortId: String, $scenarioId: String, $exampleScenarioId: String, $productExternalId: String, $data: String) {
  trackEvent(
    event: {name: $name, customerKey: $customerKey, appUserShortId: $appUserShortId, scenarioId: $scenarioId, scenarioType: $scenarioType, exampleScenarioId: $exampleScenarioId, productExternalId: $productExternalId, data: $data}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrackEventGQL extends Apollo.Mutation<TrackEventMutation, TrackEventMutationVariables> {
    override document = TrackEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerConfigDocument = gql`
    query GetCustomerConfig($customerKey: String!) {
  getCustomer(customerKey: $customerKey) {
    name
    homepageUrl
    isInMaintenance
    config {
      logoPath
      defaultLanguage
      translationsPath
      useFavoritesList
      showDoorVisionBranding
      showRefineLayoutAfterUpload
      productLinkType
      enabledShadowProfiles
      showGlassLayerInVisualization
      shopLinkOverwrite
      mainDoorTypeFilter {
        ...SmallProductType
      }
      gtmTag
      enabledExampleImageSets
      defaultDoorType {
        ...SmallProductType
      }
      supportedDoorTypes: productTypes(productTypeType: DOOR_TYPE) {
        ...SmallProductType
      }
      allowMultipleDoors
      allowClippedCorners
      supportedProductTypes
      enableShadowInpainting
      enabledProducts
      hideShareButton
      enableDoorTypeDropdownSelection
      showCustomAttributesFilter
      hideDownloadButton
      hideFlipButton
      hideRefineButtonUnderImage
      showVisitHomepageButton
      alwaysShowImageButtons
      logoPlacement
      imageButtonsArrangement
      imageButtonsPlacement
      enableVisualDoorsSearch
      colors {
        primary
        primaryText
        uploadPanelText
        uploadPanelBackground
        imageButtonsBackground
        imageButtonsText
      }
    }
  }
}
    ${SmallProductTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomerConfigGQL extends Apollo.Query<GetCustomerConfigQuery, GetCustomerConfigQueryVariables> {
    override document = GetCustomerConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorsStateServiceDocument = gql`
    query GetVisualDoorsStateService($customerKey: String!, $filter: FilterContextInput, $paginationModel: PaginationModel) {
  getVisualDoors(
    customerKey: $customerKey
    filter: $filter
    pagination: $paginationModel
  ) {
    paginationMode
    cursorBasedPaginationInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    pageInfo {
      page
      pageSize
      totalResults
      totalPages
    }
    results {
      ...Door
    }
  }
}
    ${DoorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorsStateServiceGQL extends Apollo.Query<GetVisualDoorsStateServiceQuery, GetVisualDoorsStateServiceQueryVariables> {
    override document = GetVisualDoorsStateServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorDocument = gql`
    query GetVisualDoor($customerKey: String!, $externalId: String!) {
  getVisualDoorForExternalIdAndCustomer(
    customerKey: $customerKey
    externalId: $externalId
  ) {
    ...DoorWithShadowProfiles
  }
}
    ${DoorWithShadowProfilesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorGQL extends Apollo.Query<GetVisualDoorQuery, GetVisualDoorQueryVariables> {
    override document = GetVisualDoorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountFavoritesDocument = gql`
    query countFavorites($customerKey: String!) {
  getFavoriteCount(customerKey: $customerKey)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountFavoritesGQL extends Apollo.Query<CountFavoritesQuery, CountFavoritesQueryVariables> {
    override document = CountFavoritesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleVisualDoorFavoriteDocument = gql`
    mutation toggleVisualDoorFavorite($visualDoorId: String!) {
  toggleVisualDoorFavorite(visualDoorId: $visualDoorId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleVisualDoorFavoriteGQL extends Apollo.Mutation<ToggleVisualDoorFavoriteMutation, ToggleVisualDoorFavoriteMutationVariables> {
    override document = ToggleVisualDoorFavoriteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorsFilterOptionsDocument = gql`
    query GetVisualDoorsFilterOptions($filter: FilterContextInput) {
  getVisualDoorsFilterOptions(filterInput: $filter) {
    heroFilterOptions {
      imageUrl
      title
      description
      categoryOptionsToSelect {
        categoryId
        selectAllOptions
        optionsToSelect
      }
    }
    doorTypeOptions {
      doorType {
        ...SmallProductType
      }
      description
      svgImageUrl
    }
    sortingOptions {
      id
      name
    }
    categories {
      id
      name
      enabled
      description
      options {
        id
        description
        count
        imageUrl
      }
    }
  }
}
    ${SmallProductTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorsFilterOptionsGQL extends Apollo.Query<GetVisualDoorsFilterOptionsQuery, GetVisualDoorsFilterOptionsQueryVariables> {
    override document = GetVisualDoorsFilterOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductDocument = gql`
    query GetProduct($externalId: String!, $customerKey: String!) {
  getProductByExternaldId(externalId: $externalId, customerKey: $customerKey) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductGQL extends Apollo.Query<GetProductQuery, GetProductQueryVariables> {
    override document = GetProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedProductsDocument = gql`
    query GetPaginatedProducts($filter: ProductFilter, $pagination: PaginationModel) {
  getPaginatedProducts(filter: $filter, pagination: $pagination) {
    __typename
    cursorBasedPaginationInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    results {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedProductsGQL extends Apollo.Query<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables> {
    override document = GetPaginatedProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserScenariosForAppUserDocument = gql`
    query GetUserScenariosForAppUser {
  getAppUser {
    id
    getUserScenarios {
      ...UserScenario
    }
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserScenariosForAppUserGQL extends Apollo.Query<GetUserScenariosForAppUserQuery, GetUserScenariosForAppUserQueryVariables> {
    override document = GetUserScenariosForAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserScenarioForAppUserDocument = gql`
    mutation DeleteUserScenarioForAppUser($userScenarioId: String!) {
  deleteUserScenarioForAppUser(userScenarioShortId: $userScenarioId) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserScenarioForAppUserGQL extends Apollo.Mutation<DeleteUserScenarioForAppUserMutation, DeleteUserScenarioForAppUserMutationVariables> {
    override document = DeleteUserScenarioForAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExampleImagesDocument = gql`
    query GetExampleImages($customerKey: String!, $doorTypeId: String!, $setNumber: Int) {
  getExampleImages(
    customerKey: $customerKey
    doorTypeId: $doorTypeId
    setNumber: $setNumber
  ) {
    verticals {
      ...ExampleScenario
    }
    horizontals {
      ...ExampleScenario
    }
  }
}
    ${ExampleScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExampleImagesGQL extends Apollo.Query<GetExampleImagesQuery, GetExampleImagesQueryVariables> {
    override document = GetExampleImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultCornersDocument = gql`
    query GetDefaultCorners($imageWidth: Float!, $imageHeight: Float!, $doorTypeId: String!) {
  getDefaultCorners(
    imageWidth: $imageWidth
    imageHeight: $imageHeight
    doorTypeId: $doorTypeId
  ) {
    index
    doorType {
      ...SmallProductType
    }
    topLeft {
      x
      y
    }
    topRight {
      x
      y
    }
    bottomLeft {
      x
      y
    }
    bottomRight {
      x
      y
    }
  }
}
    ${SmallProductTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultCornersGQL extends Apollo.Query<GetDefaultCornersQuery, GetDefaultCornersQueryVariables> {
    override document = GetDefaultCornersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCornersDocument = gql`
    mutation UpdateCorners($userScenarioId: String!, $corners: [DoorCornersInput!]!, $customData: String) {
  refineCorners(
    userScenarioId: $userScenarioId
    corners: $corners
    customData: $customData
  ) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCornersGQL extends Apollo.Mutation<UpdateCornersMutation, UpdateCornersMutationVariables> {
    override document = UpdateCornersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserScenarioFromUploadDocument = gql`
    mutation CreateUserScenarioFromUpload($createUserScenarioParameters: CreateUserScenarioParameters!) {
  createUserScenario(parameters: $createUserScenarioParameters) {
    showCornerRefinement
    userScenario {
      ...UserScenario
    }
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserScenarioFromUploadGQL extends Apollo.Mutation<CreateUserScenarioFromUploadMutation, CreateUserScenarioFromUploadMutationVariables> {
    override document = CreateUserScenarioFromUploadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserScenarioByShortIdDocument = gql`
    query GetUserScenarioByShortId($shortId: String!) {
  getUserScenarioByShortId(shortId: $shortId) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserScenarioByShortIdGQL extends Apollo.Query<GetUserScenarioByShortIdQuery, GetUserScenarioByShortIdQueryVariables> {
    override document = GetUserScenarioByShortIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewAppUserDocument = gql`
    mutation createNewAppUser {
  createNewAppUser {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewAppUserGQL extends Apollo.Mutation<CreateNewAppUserMutation, CreateNewAppUserMutationVariables> {
    override document = CreateNewAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query GetUser($customerKey: String!) {
  getCustomer(customerKey: $customerKey) {
    name
    config {
      logoPath
      defaultLanguage
      translationsPath
      useFavoritesList
      showDoorVisionBranding
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    override document = GetUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }